import api from './axiosConfig';

export type AdPlatform = 'meta' | 'google';

/** 管理画面「広告アカウント」の1行。トークンは返らず、ID は末尾だけ */
export interface AdminAdAccountRow {
  id: number;
  organization: { id: number; name: string } | null;
  platform: AdPlatform;
  account_name: string | null;
  account_id_suffix: string;
  status: string;
  is_test_account: boolean;
  connected_by: string | null;
  connected_at: string | null;
  last_synced_at: string | null;
}

export interface AdminAdAccountFilters {
  platform?: AdPlatform | '';
  status?: string;
}

export interface AdminAdAccountList {
  rows: AdminAdAccountRow[];
  /** 絞り込み後の総件数。rows は上限（limit）までしか返らない */
  total: number;
  limit: number;
}

const adminAdAccountService = {
  async list(filters: AdminAdAccountFilters = {}): Promise<AdminAdAccountList> {
    const params: Record<string, string> = {};
    if (filters.platform) params.platform = filters.platform;
    if (filters.status) params.status = filters.status;
    const response = await api.get<{ success: boolean; data: AdminAdAccountRow[]; meta: { total: number; limit: number } }>(
      '/admin/ad-accounts',
      { params },
    );
    return { rows: response.data.data, total: response.data.meta.total, limit: response.data.meta.limit };
  },
};

export default adminAdAccountService;
